import React from 'react';
import { AlertTriangleIcon } from 'lucide-react';
import { Countdown } from './ui/Countdown';
export function UrgencySection() {
  return <section className="bg-slate-950 text-center text-stone-50" aria-label="Limited time offer" data-id="element-213" data-mp="2sk46nkhn1yb1">
      <div className="h-1 w-full bg-amber-400" aria-hidden="true" data-id="element-214" data-mp="36bimjig91jdv" />
      <div className="mx-auto max-w-3xl px-4 py-12" data-id="element-215" data-mp="31iz9qnpdysa4">
        <p className="inline-flex items-center gap-2 text-sm font-bold uppercase tracking-[.16em] text-amber-400" data-id="element-216" data-mp="31h4rjh5i1e9q">
          <AlertTriangleIcon className="h-4 w-4" aria-hidden="true" data-id="element-217" data-mp="3b90ylhpkceq3" /> Launch pricing ends in:
        </p>
        <Countdown className="mt-5" data-id="element-218" data-mp="3p8jvfecxc3n3" />
        <p className="mt-7 font-bold text-slate-300" data-id="element-219" data-mp="3p7ij76k69b3s">After that the price increases and never drops again.</p>
      </div>
      <div className="h-1 w-full bg-amber-400" aria-hidden="true" data-id="element-220" data-mp="3l7zxw9ofuy0f" />
    </section>;
}